import { Box, Container, Typography } from '@mui/material';
import { AppState, DefaultProps } from '../../types/types';


import React from "react";
interface FooterProps extends DefaultProps {
    appState: AppState,
}


function Footer(props: FooterProps) {
    let impressum = props.appState?.customizing?.impressumSrc || 'https://www.rheinland-versicherungen.de/impressum/';
    let datenschutz = props.appState?.customizing?.datenschutzSrc || 'https://www.rheinland-versicherungen.de/datenschutz/digitales-postfach';

    let agb = props.appState?.customizing?.agbSrc;
    let kontaktdatenAendern = props.appState?.customizing?.kontaktdatenAendern;
    let faq = props.appState?.customizing?.faq;
    let postfix = props.appState?.customizingId || 'rl';
    let showFlixcheck = (postfix === 'RHEINLAND' || postfix === 'rl');
    let showCopyright = props.appState.customizingId === 'rl';

    const currentYear = new Date().getFullYear();
    return (
        <Box sx={{
            backgroundColor: 'footer.main' || '#0069b4',
            color: 'footer.contrastText' || '#4444',
            fontWeight: '700',
            bottom: 0,
            padding: 0,
            margin: 0,
            width: '100%',
            paddingBottom: '12px',
            paddingTop: '14px',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            "& a:hover": {
                textDecoration: 'underline',
            },
            "& a": {
                textDecoration: 'none',
                color: 'footer.contrastText' || '#4444'
            },
        }}

        >
            <Container maxWidth='lg' sx={{}}>
                <Box sx={{
                    margin: '0 auto',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexFlow: 'wrap',
                    width: '100%',
                    maxWidth: '750px',
                    justifyContent: 'space-between',
                    gap: '20px',
                    padding: '20px 40px',
                    "& a": {
                        fontSize: '14px'
                    }
                }}>
                    <Box sx={{padding: '0.5em'}}>
                        <a href={impressum} target="_blank" rel="noreferrer">Impressum</a>
                    </Box>
                    {showFlixcheck && <Box sx={{padding: '0.5em'}}>
                        <a href={("" + process.env.REACT_APP_RHEINLAND_FLIXCHECK_TECHNISCHE_UNTERSTUETZUNG_URL)}
                           target="_blank" rel="noreferrer">Technische Unterstützung</a>
                    </Box>}
                    <Box sx={{padding: '0.5em'}}>
                        <a href={datenschutz} target="_blank" rel="noreferrer">Datenschutz</a>
                    </Box>
                    {!!faq && <Box  sx={{padding: '0.5em'}}>
                        <a href={faq} target="_blank" rel="noreferrer">FAQ</a>
                    </Box>}


                    {!!agb && <Box sx={{padding: '0.5em'}} >
                        <a href={agb} target="_blank" rel="noreferrer">Nutzungsbedingungen</a>
                    </Box>}


                    {!!kontaktdatenAendern && <Box sx={{padding: '0.5em'}} >
                        <a href={kontaktdatenAendern} target="_blank" rel="noreferrer">Kontaktdaten ändern</a>
                    </Box>}
                </Box>

            </Container>
            {showCopyright && <Box sx={{padding: '0.5em'}}><Typography component="span">© RheinLand Versicherungen {currentYear}</Typography></Box>}

        </Box>
    );
}
export default Footer;